module.exports = __webpack_public_path__ + "img/btn_address.37292dfe.png";